export default "__VITE_ASSET__DBd7jOmx__"